import React, { Fragment, useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Media
} from "reactstrap";
import { Btn, H4, Image, Spinner } from "../../../AbstractElements";
import {
  EditProfile,
  Company,
  Username,
  UsersCountryMenu,
  AboutMe,
  UpdateProfile,
  FirstName,
  LastName,
  Address,
  EmailAddress,
  PostalCode,
  Country,
  City,
} from "../../../Constant";
import { useLocation } from  "react-router-dom";
import axios from "axios";
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";


const EditMyProfile = () => {
  const phonee = localStorage?.getItem("currentUser");
  const token = localStorage?.getItem("token");
  const [name, setName] = React.useState("");
  const { t } = useTranslation();
  const [phone_number, setPhoneNumber] = React.useState(phonee);
  const [profile_pic, setProfilePic] = React.useState("");
  const [position, setPosition] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [profilePicValid, setProfilePicValid] = useState(true);
  const [profile_image, setProfileImage] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [profileFile, setProfileFile] = React.useState();

  useEffect(() => {
    handle_get_profile();
  }, []);



  const resizeImage = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions to maintain aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = Math.round(height * (maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round(width * (maxHeight / height));
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          // Draw the resized image onto the canvas
          ctx.drawImage(img, 0, 0, width, height);

          // Convert canvas to a Blob, then to a File
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error('Canvas to Blob conversion failed.'));
                return;
              }
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            },
            file.type,
            0.95 // Image quality for JPEG/WEBP (0.0 to 1.0)
          );
        };

        img.onerror = (error) => reject(error);
      };

      reader.onerror = (error) => reject(error);
    });
  };


  const getUploadParams4 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const validateImageDimensions = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new window.Image();;
      img.src = event.target.result;

      img.onload = () => {
        const maxWidth = 134; // Maximum allowed width
        const maxHeight = 170; // Maximum allowed height

        if (img.width > maxWidth || img.height > maxHeight) {
          callback(
            false,
            `Image dimensions must be ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
          );
        } else {
          callback(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChangeStatus4 = async ({ meta, file, remove }, status) => {
    if (status === 'done') {
      try {
        // Resize the image to fit within a 134x170 box
        const resizedFile = await resizeImage(file, 134, 170);

        console.log('Original file size:', file.size);
        console.log('Resized file size:', resizedFile.size);

        // Set the new, resized file in your state
        setProfilePic(resizedFile);

        toast.success('Image has been resized and is ready!');

      } catch (error) {
        console.error('Image processing failed:', error);
        toast.error('Could not process the image. Please try a different file.');
        remove(); // Remove the file from the dropzone on error
      }
    }

    if (status === 'removed') {
      // Handle file removal if needed
      setProfilePic(null);
    }
  };

  const handle_get_profile = async () => {
    try {
      setLoading(true);
      const response2 = await axios.get(
        `https://api-portal.nada.org.np/api/users/profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response2?.data?.success) {
        setLoading(false);
        //setData(response2?.data?.data?.firms);
        setName(response2?.data?.data?.user?.[0]?.name);
        setPhoneNumber(response2?.data?.data?.user?.[0]?.phone_number);
        setProfileImage(response2?.data?.data?.user?.[0]?.profile_pic);
        setPosition(response2?.data?.data?.user?.[0]?.position);
        const name = response2?.data?.data?.user?.[0]?.name ? response2?.data?.data?.user?.[0]?.name : 'null';
        const image = response2?.data?.data?.user?.[0]?.profile_pic ? response2?.data?.data?.user?.[0]?.profile_pic : 'null';
        const position = response2?.data?.data?.user?.[0]?.position ? response2?.data?.data?.user?.[0]?.position : 'null';
        localStorage.setItem("image", image);
        localStorage.setItem("position", position);
        localStorage.setItem("Name", name);
        localStorage.setItem("currentUser", response2?.data?.data?.user?.[0]?.phone_number);
      }
    } catch (error) {
      setLoading(false);
      if (error?.response) {

        console.error("Error response:", error?.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };



  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onEditSubmit = (data, files, allFiles) => {
    allFiles.forEach((f) => f.remove());
    toast.success("Dropzone successfully submitted !");
    alert("Form is Submitted");
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let actualImage = null;
      if (profileFile) {
        actualImage = await call_picture_upload(profileFile);
      }

      const response2 = await axios.put(
        "https://api-portal.nada.org.np/api/users",
        {
          phone_number: phone_number,
          password: password,
          profile_pic: actualImage !== null? actualImage : profile_image,
          name: name,
          position: position
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        },
      );
      if (response2?.data?.success) {
        setLoading(false);
        handle_get_profile();
        toast.success(response2?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };


  const call_picture_upload = async (file) => {
    // 1. Get the Presigned URL
    const getUrl = await axios.get(
      `https://api-portal.nada.org.np/api/upload-url?filename=${file.name}&fileType=${file.type}`,
      {
        headers: {
             // Ensure you are sending auth if your backend requires it
            'Authorization': `Bearer ${token}`
        },
      }
    );

    const { uploadUrl, key } = getUrl.data;

    // 2. Upload to S3 (Crucial Fix Here)
    await axios.put(
      uploadUrl,
      file, // <--- Pass 'file' directly. Do NOT wrap in { body: file }
      {
        headers: {
            "Content-Type": file.type
        }
      }
    );

    return "https://d24xzirvx50zjt.cloudfront.net/" + key;
};

  return (
    <Fragment>
      <Form className="card" onSubmit={handleEdit}>
        <CardHeader className="pb-0">
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="5">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Name")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Name")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  //{...register("name", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {errors.company && "Company is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Phone Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  placeholder={t("Phone Number")}
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {errors.Username && "Username is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            {profile_image &&
            <Col sm="6" md="3">
              <FormGroup style={{ display: 'flex', flexDirection: 'column' }}>
                {" "}
                <Label className="form-label">{t("Current Passport Size Photo")}</Label>
                <Image attrImage={{
                  body: true, className: 'img-100 rounded-circle', src: `${profile_image}`, alt: '',
                }}
                />
              </FormGroup>
            </Col>
            }
            <Col md="5">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Password")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Password")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  //{...register("name", { required: true })}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Position")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Position")}
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  //{...register("name", { required: true })}
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <div>
                {" "}
                <Label className="form-label">
                  {t("Update Contact Person Passport Photo")}(jpeg/png,134 * 170)
                </Label>
                <Dropzone1
                  accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams4}
                  placeholder="Photo"
                  handleChangeStatus={handleChangeStatus4}
                />
                <span style={{ color: "red" }}>
                  {!profilePicValid && t("PP photo is required")}{" "}
                </span>
              </div>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="text-end">
        {
            loading?
              <div className="loader-box">
              <Spinner attrSpinner={{ className: 'loader-2' }} />
            </div> : <Btn attrBtn={{ color: "primary", type: "submit" }}>{t("Update Profile")}</Btn>
          }
        </CardFooter>
      </Form>
    </Fragment>
  );
};
export default EditMyProfile;
